<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-sticky tw-top-0 tw-z-10">
            <div class="tw-mx-auto tw-px-6 tw-py-4 tw-flex tw-justify-between tw-items-center">
                <div>
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-2xl tw-font-bold">Adicionar Leituras</h1>
                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-sm tw-mt-1">Carregue arquivo JSON do coletor Winckieel</p>
                </div>
            </div>
        </div>

        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-mx-auto tw-p-6">
            <div class="tw-max-w-2xl tw-mx-auto">
                <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-6 tw-shadow-sm">
                    <div class="tw-flex tw-items-center tw-gap-3 tw-mb-8">
                        <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'">
                            <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
                        </div>
                        <div>
                            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Importar Arquivo JSON</h3>
                        </div>
                    </div>

                    <form @submit.prevent="handleSubmit" class="tw-space-y-6">
                        <div>
                            <label for="siloSelect" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-block tw-text-sm tw-font-semibold tw-mb-3">
                                Selecione o Silo
                            </label>
                            <select 
                                id="siloSelect" 
                                v-model="selectedSilo"
                                required
                                :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-200 tw-text-black'"
                                class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 w-pr-10"
                            >
                                <option value="">-- Selecione um silo --</option>
                                <option v-for="silo in silos" :key="silo.id" :value="silo.id">{{ silo.nome }}</option>
                            </select>
                        </div>

                        <div>
                            <label for="jsonFile" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-block tw-text-sm tw-font-semibold tw-mb-3">
                                Arquivo JSON
                            </label>
                            <div :class="theme === 'dark' ? 'tw-border-slate-700/50 hover:tw-border-slate-700 tw-bg-[#1a1d21]' : 'tw-border-slate-400 hover:tw-border-slate-300 tw-bg-gray-200 tw-text-black'" class="tw-relative tw-border-2 tw-border-dashed tw-rounded-xl tw-p-8 tw-text-center tw-cursor-pointer hover:tw-bg-opacity-70">
                                <input 
                                    type="file" 
                                    id="jsonFile" 
                                    @change="handleFileChange"
                                    accept=".json"
                                    required
                                    class=" tw-absolute tw-inset-0 tw-w-full tw-h-full tw-opacity-0 tw-cursor-pointer"
                                />
                                <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-2">
                                    <svg class="tw-w-10 tw-h-10 tw-mx-auto" :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/></svg>
                                    <div>
                                        <p :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm tw-font-medium">
                                            {{ jsonFile ? jsonFile.name : 'Clique para selecionar ou arraste o arquivo' }}
                                        </p>
                                        <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-500'" class="tw-text-xs tw-mt-1">Arquivo JSON do AutoColetor Winckieel</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tw-flex tw-gap-3 tw-justify-end tw-pt-4">
                            <button 
                                type="button"
                                @click="limparForm"
                                :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'"
                                class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl"
                            >
                                Cancelar
                            </button>
                            <button 
                                type="submit"
                                :disabled="!formularioPreenchido"
                                :class="theme === 'dark' ? 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-500/20 disabled:tw-opacity-50' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-100 disabled:tw-opacity-50'"
                                class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-cursor-not-allowed"
                            >
                                Enviar Leitura
                            </button>
                        </div>
                    </form>
                </section>
            </div>
        </main>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import { mapState } from 'vuex';

export default {
    components: {
        MainLayout,
        LoaderPage
    },

    setup() {
        const silos = ref([]);
        const store = useStore();
        const unidade = ref({});
        const toast = useToast();
        const loadingPage = ref(true);
        const route = useRoute();
        const selectedSilo = ref('');
        const jsonFile = ref(null);
        const formularioPreenchido = ref(false);

        onMounted(async () => {
            loadingPage.value = true;
            const unidadeId = route.params.unidade;

            try {
                await store.dispatch("unidade/fetchUnidade", unidadeId);
                unidade.value = store.state.unidade.unidade;

                await store.dispatch("silos/fetchSilosByUnidade", unidadeId);
                silos.value = store.state.silos.silos;

            } catch (error) {
                console.error("Erro ao buscar unidade ou silos:", error);
                toast.error("Erro ao buscar dados");
            }
            loadingPage.value = false;
        });

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                jsonFile.value = file;
            }
        };

        const handleSubmit = async () => {
            let siloId = selectedSilo.value;
            let json = jsonFile.value;

            try {
                const response = await store.dispatch("leituras/uploadLeitura", { siloId, json });
                (response.data.status == 200 ? toast.success : toast.error)(response.data.response);
                limparForm();
            } catch (error) {
                toast.error(error.response.data.error || "Erro ao enviar leitura");
            }
        };

        const limparForm = () => {
            selectedSilo.value = null;
            jsonFile.value = null;
            document.getElementById('jsonFile').value = null;
        };

        watch([selectedSilo, jsonFile], () => {
            formularioPreenchido.value = !!selectedSilo.value && !!jsonFile.value;
        });

        return {
            loadingPage,
            silos,
            selectedSilo,
            handleFileChange,
            handleSubmit,
            limparForm,
            formularioPreenchido,
            jsonFile
        }
    },

    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
    }
}
</script>
